import React from 'react';

export const HintIcon = () => (
  <svg width="24px" height="24px" viewBox="0 0 24 24">
    <g stroke="none" strokeWidth="1" fill="none">
      <path
        stroke="#888888"
        strokeWidth="2"
        d="M12,1 C18.0752847,1 23,5.92471525 23,12 C23,18.0752847 18.0752847,23 12,23 C5.92471525,23 1,18.0752847 1,12 C1,5.92471525 5.92471525,1 12,1 Z"
      />
      <path fill="#888888" d="M13,17 L11,17 L11,11 L13,11 L13,17 Z M13,9 L11,9 L11,7 L13,7 L13,9 Z" />
    </g>
  </svg>
);
